import csv from 'csvtojson';

export const parseAccountIdsFromString = async (value: string): Promise<Array<string>> => {
  const parser = csv({ noheader: true, trim: true, output: 'csv' });
  const parseResult = await parser.fromString(value);
  return parseResult.flat();
};
